// extracted by mini-css-extract-plugin
module.exports = {"point":"style_point__sXlhQ","title":"style_title__-cZ3X"};